<template>
  <div class="page" v-if="$conFun.clientWidth() > 768">
    <Nav isActive="6" :isIndex="isIndex" />
    <div style="position: relative" class="pb100">
      <img
        src="http://h5.shihua.com/static/yunxue/newsbg.png?v=1"
        style="width: 100%"
      />
      <!-- <div style="position: absolute; top: 150px; left: 0; width: 100%">
        <div class="pageWD">
          <div class="cter cff" style="padding-bottom: 30px">
            <div class="f36 pb10">免费咨询</div>
            <div class="f20">Free consultation</div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="pageWD">
      <div class="flex-sb" style="align-items: flex-end; margin-bottom: 70px">
        <img src="@/assets/images/s3.png" style="width: 160px; height: 78px" />
      </div>
      <div v-if="artList">
        <div
          class="flex-sb"
          v-for="(item, index) in artList"
          :key="index"
          @click="tapMeMO(item)"
        >
          <img
            :src="item.pic"
            style="width: 247px; height: 143px; border-radius: 6px"
          />
          <div
            class="newitem flex-sb"
            style="flex: 1; margin-left: 40px; height: 180px"
          >
            <div class="l" style="padding-top: 10px">
              <div class="f30 c6">{{ item.CreatedOn.substr(5, 6) }}</div>
              <div class="f16" style="color: #ababab">
                {{ item.CreatedOn.substr(0, 4) }}
              </div>
            </div>
            <div style="flex: 1">
              <div class="f20 c6" style="margin-bottom: 10px">
                {{ item.ArtTitle }}
              </div>
              <div
                class="f14 c6"
                style="
                  line-height: 26px;
                  margin-bottom: 10px;
                  height: 80px;
                  overflow: hidden;
                "
              >
                {{ item.Content }}
              </div>
              <div class="f14 c6 more" style="text-align: right">
                查看详情>>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Fotter />
  </div>

  <div class="page" v-else>
    <Nav />
    <div class="mbpage">
      <div style="position: relative">
        <img
          src="http://h5.shihua.com/static/yunxue/newsbg.png?v=1"
          style="width: 100%"
        />
      </div>

      <div style="padding:20px">
        <div >
          <img
            src="@/assets/images/s3.png"
            style="width: 120px;margin-bottom:20px"
          />
        </div>
        <div v-if="artList">
          <div
          
            v-for="(item, index) in artList"
            :key="index"
            @click="tapMeMO(item)"
          >
            <img
              :src="item.pic"
              style="width: 100%; border-radius: 6px"
            />
            <div
              class="newitem flex-sb"
              style="flex: 1;margin-top:20px; height: 180px"
            >
              <div class="l" style="padding-top: 10px">
                <div class="f30 c6">{{ item.CreatedOn.substr(5, 6) }}</div>
                <div class="f16" style="color: #ababab">
                  {{ item.CreatedOn.substr(0, 4) }}
                </div>
              </div>
              <div style="flex: 1">
                <div class="f20 c6" style="margin-bottom: 10px">
                  {{ item.ArtTitle }}
                </div>
                <div
                  class="f14 c6"
                  style="
                    line-height: 26px;
                    margin-bottom: 10px;
                    height: 80px;
                    overflow: hidden;
                  "
                >
                  {{ item.Content }}
                </div>
                <div class="f14 c6 more" style="text-align: right">
                  查看详情>>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Fotter />
  </div>
</template>
<script>
import { articleList } from "@/api/api";
import Nav from "@/components/Nav.vue";
import Fotter from "@/components/Fotter.vue";
export default {
  name: "bmtd",
  components: { Nav, Fotter },
  data() {
    return {
      artList: null,
      isIndex: 1,
      vlist: [
        {
          hide: false,
          isrc: "http://h5.shihua.com/static/yunxue/c1.png",
          src: "https://yunxue-bucket.oss-cn-shanghai.aliyuncs.com/shcms/video/%E6%9D%9C%E9%95%BF%E6%98%A5.mp4",
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    getList() {
      var that = this;
      var data = {
        ArtColumn: "shihua",
        pageIndex: "1",
        pageSize: "10",
      };
      articleList(data).then((res) => {
        console.log(res);
        that.artList = res.body.result.forumList;
      });
    },
    tapMeMO(item) {
      this.$router.push({ path: "/News/detail?id=" + item.ArtID });
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 150) {
        this.isIndex = 2;
      } else {
        this.isIndex = 1;
      }
    },
  },
};
</script>
<style scoped>
.about_s1 {
  background: url("http://h5.shihua.com/static/yunxue/about_bg.png") repeat-x;
}
.jnm {
  font-size: 36px;
  color: #333;
  font-weight: 800;
  position: relative;
  padding-bottom: 40px;
  padding-top: 40px;
}
.jnm:after {
  content: "";
  position: absolute;
  bottom: 20px;
  width: 54px;
  height: 6px;
  background: #25a2dd;
  left: 0;
}
.ctt {
  background: url("http://h5.shihua.com/static/yunxue/picbg.png") no-repeat;
  width: 553px;
  height: 195px;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  padding: 25px 40px;
  position: relative;
  left: -15px;
}
</style>


// WEBPACK FOOTER //
// src/views/news/index.vue